import { getBearerToken, isAdmin, mouseEventStyles, Page, dynamicResourceLinks } from "./util";
import ControlPannel from "./ControlPannel";
import CustomLink from "./CustomLink";
import axios from "axios";
import $ from 'jquery'

const EditProfile = () => {
	return (
		<Page className="create-user">
			<div className="navpad h50"></div>
			<ControlPannel >
				{
					isAdmin()
						?
						<CustomLink className="users left"
							to={"/users"}
							{...mouseEventStyles(
								{ backgroundColor: "rgba(255, 255, 255, 0.2)" },
								{ backgroundColor: "rgba(255, 255, 255, 0.3)" }
							)}>
							<img src={dynamicResourceLinks("ff09ff").userIcon} alt="" className="icon" />
							<div className="tooltip">
								manage users
							</div>
						</CustomLink>
						:
						<div></div>
				}
				<div></div>
			</ControlPannel>
			<form action="" onSubmit={(e) => {
				e.preventDefault()
				var data = new FormData();
				var count = 0
				var append = (key) => {
					if ($("#" + key).val() !== "") {
						count++
						console.log("append key: " + key + " with value: |" + $("#" + key).val() + "|")
						data.append(key, $("#" + key).val())
					}
				}
				append('username');
				append('name');
				append('email');
				// data.append('avatar', 1)
				if (count)
					axios.put("https://api.pcbang.ma/api/users/me", data, {
						headers: {
							Authorization: getBearerToken(),
							'Content-Type': 'multipart/form-data'
						}
					}).then((res) => {
						if (res.status / 100 === 2) {
							$("#message").removeAttr("style")
							$("#message").text("Success!")
							$("#message").attr("style", "color: lime")
						}
					}).catch((err) => {
						console.log({ err })
						$("#message").removeAttr("style")
						$("#message").text(err.response.data.error.message + "!")
						$("#message").attr("style", "color: orangered")
					})
			}}>
				<label htmlFor="">Username: </label>
				<input type="text" name="" id="username" />
				<label htmlFor="">Author Name: </label>
				<input type="text" name="" id="name" />
				<label htmlFor="">Email: </label>
				<input type="text" name="" id="email" />
				<p htmlFor="" id="message" className="flex-as-cr"><wbr></wbr></p>
				<input type="submit" name="submit" value="Save Changes" className="submitbutton" />
				<div></div>
				<p style={{fontSize: "80%", color: "gray", textAlign: "center"}}><span style={{color: "red"}}>*&nbsp;</span>If not changing a certain information, leave it's field blank</p>
				<div className="navpad"></div>
			</form>
		</Page>
	);
}

export default EditProfile;